<tp-modal dialogTitle="Edit Space" [isBusy]="isSubmitting$ | async">
  <tp-form [formGroup]="form" [isSubmitting$]="isSubmitting$" (doSubmit)="submit()">
    <tp-form-input type="text" [form]="form" field="id" label="Space ID" />
    <tp-form-input type="text" [form]="form" field="name" label="Space Name" />
    <tp-form-actions
      [cancellable]="true" [submitDisabled]="!form.dirty" submitText="Save" [isSubmitting]="isSubmitting$ | async"
      buttonIdPrefix="editSpaceModal" (cancel)="close()"
    />
  </tp-form>
</tp-modal>
